@let vm = vm$ | async;

<header class="flex flex-wrap items-center gap-4 bg-white min-h-[45px] sm:min-h-[60px]">
  <div class="flex w-full items-center justify-between gap-2 px-2 lg:w-auto lg:flex-1 lg:px-0">
    @if (vm.isMobile) {
      <button class="action-button" appMobileSidebarToggler>
        <i class="fa fa-bars"></i>
      </button>
    }

    <a [routerLink]="defaultRoute" [class]="vm.isMobile ? 'mobile-logo' : 'desktop-logo'">
      <img [src]="vm.brandLogoUrl" class="max-h-[60px] md:max-h-[70px]" />
    </a>

    @if (vm.inlineActions) {
      <div class="flex items-center gap-4 text-sm xl:ml-auto px-5">
        <ng-container [ngTemplateOutlet]="actions" />
      </div>
    } @else {
      <button [matMenuTriggerFor]="actionsMenu" class="action-button mr-0 lg:mr-5">
        <i class="fa fa-user-circle"></i>
        @if(!vm.compactMenu) {
          <span>{{ vm.userName }}</span>
        }
      </button>
    }
  </div>
</header>

<mat-menu #actionsMenu="matMenu">
  <ng-container [ngTemplateOutlet]="actions" />
</mat-menu>

<ng-template #actions>
  @let style = vm.inlineActions ? 'action-button' : 'menu-button';

  @if(vm.inlineActions) {
    <div class="action">
      <i class="fa fa-user-circle"></i>
      <span>{{ vm.userName }}</span>
    </div>
  }
  @else if(vm.compactMenu) {
    <div class="action">
      <span>{{ vm.userName }}</span>
    </div>
  }
  <button (click)="onSupportClick()" [class]="style">
    <i class="fa fa-life-ring"></i>
    <span>{{ 'Support' | translate: vm.locale | async }}</span>
  </button>
  @if (showLanguageOptions) {
    <button (click)="onLanguageClick()" [class]="style">
      <i class="fa fa-language"></i>
      <span>{{ 'Language' | translate: vm.locale | async }}</span>
    </button>
  }
  <button (click)="onLogoutClick()" [class]="style">
    <i class="fa fa-sign-out"></i>
    <span>{{ 'Log Out' | translate: vm.locale | async }}</span>
  </button>
</ng-template>
